export default __webpack_public_path__ + "static/media/R4.0996a788.JPG";